import { REQUEST_MYAPPLICATIONS,
        RECEIVE_MYAPPLICATIONS_SUCCESS,
        RECEIVE_MYAPPLICATIONS_ERROR,
        REQUEST_MYLOANS,
        RECEIVE_MYLOANS_SUCCESS,
        RECEIVE_MYLOANS_ERROR,
        RECEIVE_CONFIRMAPPLICATIONBYBORROWER_SUCCESS } from '../actions/application';

export function borrower(state = {isFetching: true, applications: [], loans: [] } , action) {
            
            switch (action.type) {
        
                case REQUEST_MYAPPLICATIONS: {
                    let newstate = {...state, 
                        loans: state.loans,
                        applications: state.applications,
                        isFetching: true};

                    return newstate;
                }
                case RECEIVE_MYAPPLICATIONS_SUCCESS: {        
                    let newstate = {...state,
                        isFetching: false,
                        loans: state.loans,
                        applications: action.application,
                        };

                    return newstate;
                }
                case REQUEST_MYLOANS: {
                    let newstate= {...state,
                        loans: state.loans,
                        applications: state.applications,
                        isFetching: true};

                    return newstate;
                }
                case RECEIVE_MYLOANS_SUCCESS: {
                    let newstate = {...state,
                        loans: action.loans,
                        applications: state.applications,
                        isFetching: false}

                    return newstate;
                }

                /*
                function updateVeryNestedField(state, action) {
    return {
        ...state,
        first : {
            ...state.first,
            second : {
                ...state.first.second,
                [action.someId] : {
                    ...state.first.second[action.someId],
                    fourth : action.someValue
                }
            }
        }
    }
}
    */

                case RECEIVE_CONFIRMAPPLICATIONBYBORROWER_SUCCESS: {
                    let index = state.applications.findIndex(x => x.id==action.application.id);
                    if (index < 0) 
                        break;
                    let newState = 
                        {...state,
                            applications: [...state.applications],
                            isFetching: true}    
                        newState.applications[index] =  {...state.applications[index], 
                                loanApplicationStatusTypeEnum: 2};
                            
                    return newState;
                }
                case RECEIVE_MYLOANS_SUCCESS: {        
                    return {...state,
                        applications: [...state.applications],
                        isFetching: false,
                        loans: action.loans
                        }
                }
                
                default: 
                    return state;
            }
}

export function borrowerLoans(state = {isFetching: true,loans: [] } , action) {
    
    switch (action.type) {

        case REQUEST_MYLOANS: {
            return {...state, 
                loans: [...state.loans],
                isFetching: true}
        }
        case RECEIVE_MYLOANS_SUCCESS: {        
            return {...state,
                isFetching: false,
                loans: action.loans
                }
        }
        
        default: 
            return state;
    }
}